var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-page",
    { attrs: { padding: "" } },
    [
      _c(
        "div",
        { staticClass: "q-display-1 q-mb-md text-secondary" },
        [
          _c("q-icon", {
            staticClass: "q-mb-sm",
            attrs: { name: "far fa-bullhorn" }
          }),
          _vm._v(" " + _vm._s(_vm.$t("campaigns")) + "\n\t")
        ],
        1
      ),
      _c(
        "q-tabs",
        {
          model: {
            value: _vm.tab,
            callback: function($$v) {
              _vm.tab = $$v
            },
            expression: "tab"
          }
        },
        [
          _c("q-tab", {
            attrs: {
              slot: "title",
              name: "basic_data",
              label: _vm.$t("basic_data")
            },
            slot: "title"
          }),
          _vm.showTab
            ? _c("q-tab", {
                attrs: {
                  slot: "title",
                  name: "levels",
                  label: _vm.$t("levels")
                },
                slot: "title"
              })
            : _vm._e(),
          _vm.showTab
            ? _c("q-tab", {
                attrs: {
                  slot: "title",
                  name: "company_branches",
                  label:
                    _vm.$t("company_branches") +
                    " (" +
                    _vm.company_branches.length +
                    ")",
                  color: _vm.error_company_branches ? "negative" : ""
                },
                slot: "title"
              })
            : _vm._e(),
          _vm.showTab
            ? _c("q-tab", {
                attrs: {
                  slot: "title",
                  name: "brands",
                  label: _vm.$t("brands") + " (" + _vm.brands.length + ")",
                  color: _vm.error_brands ? "negative" : "",
                  disable: !_vm.allow_sells
                },
                slot: "title"
              })
            : _vm._e(),
          _vm.showTab
            ? _c("q-tab", {
                attrs: {
                  slot: "title",
                  name: "product_types",
                  label:
                    _vm.$t("product_types") +
                    " (" +
                    _vm.product_types.length +
                    ")",
                  color: _vm.error_product_types ? "negative" : "",
                  disable: !_vm.allow_sells
                },
                slot: "title"
              })
            : _vm._e(),
          _vm.showTab
            ? _c("q-tab", {
                attrs: {
                  slot: "title",
                  name: "products",
                  label: _vm.$t("products") + " (" + _vm.products.length + ")",
                  color: _vm.error_products ? "negative" : "",
                  disable: !_vm.allow_sells
                },
                slot: "title"
              })
            : _vm._e(),
          _vm.showTab
            ? _c("q-tab", {
                attrs: {
                  slot: "title",
                  name: "rewards",
                  label: _vm.$t("rewards") + " (" + _vm.rewards.length + ")",
                  color: _vm.error_rewards ? "negative" : ""
                },
                slot: "title"
              })
            : _vm._e(),
          _vm.showTab
            ? _c("q-tab", {
                attrs: {
                  slot: "title",
                  name: "photo_types",
                  label:
                    _vm.$t("photo_types") + " (" + _vm.photo_types.length + ")"
                },
                slot: "title"
              })
            : _vm._e(),
          _vm.showTab
            ? _c("q-tab", {
                attrs: {
                  slot: "title",
                  name: "configure_and_publish",
                  label: _vm.$t("configure_and_publish")
                },
                slot: "title"
              })
            : _vm._e(),
          _vm.showTab
            ? _c("q-tab", {
                attrs: {
                  slot: "title",
                  name: "audience",
                  label: _vm.$t("audience")
                },
                slot: "title"
              })
            : _vm._e(),
          _c(
            "q-tab-pane",
            { attrs: { name: "basic_data" } },
            [_c("basic-data")],
            1
          ),
          _c("q-tab-pane", { attrs: { name: "levels" } }, [_c("levels")], 1),
          _c(
            "q-tab-pane",
            { attrs: { name: "company_branches" } },
            [_c("company-branches")],
            1
          ),
          _c("q-tab-pane", { attrs: { name: "brands" } }, [_c("brands")], 1),
          _c(
            "q-tab-pane",
            { attrs: { name: "product_types" } },
            [_c("product-types")],
            1
          ),
          _c(
            "q-tab-pane",
            { attrs: { name: "products" } },
            [_c("products")],
            1
          ),
          _c("q-tab-pane", { attrs: { name: "rewards" } }, [_c("rewards")], 1),
          _c(
            "q-tab-pane",
            { attrs: { name: "photo_types" } },
            [_c("photo-types")],
            1
          ),
          _c(
            "q-tab-pane",
            { attrs: { name: "configure_and_publish" } },
            [_c("configure-and-publish")],
            1
          ),
          _c("q-tab-pane", { attrs: { name: "audience" } }, [_c("audience")], 1)
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }